import styled from 'styled-components'
import { colors } from '../../theme'

export const Container = styled.div`
  margin: 15px 0 15px 0;
`

export const Label = styled.label<{
  color?: 'fonteColor'
}>`
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 150%;
  letter-spacing: 0.5px;
  margin-left: 22px;
  color: ${({ color }) =>
    color === 'fonteColor' ? `${colors.white}` : `${colors.grey900}`};
`

export const Input = styled.input`
  margin-right: 10px;
  &:checked {
    background-color: ${colors.secondary};
    border: 2px solid ${colors.secondary};
  }
`

export const LinkStyled = styled.div`
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 150%;
  letter-spacing: 0.5px;
  color: ${colors.white};
  cursor: pointer;
  text-decoration: none;
  margin-top: 4px;
  :hover {
    color: ${colors.grey600};
  }
`
export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 318px;
  /* O espacamento vertical do cartao de login vem do gap do Wrapper da
     pagina; estas margens so somavam a ele e quebravam a regua. */
  margin: 2px 0 6px 0;
`
